import React, { Component } from "react";
import "react-table/react-table.css";
import "../../tables/reactTable.css";
import { getContactImageUrl } from "../../../config";
import { getContactImageUrl2 } from "../../../config";
import ReactTableComponent from "../../tables/ReactTable";
import {
  campaignLeadsTabList,
  campaignLeadsTabSelectList,
  campaignLeadsExport
} from "../../../Queries";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  Profileid,
  // plannedDate,
  Engaged,
  UpdatefollowUp
} from "../campaignQueries";
import editicon from "../../../../src/Components/assets/edit.png";
import { fetchMethod } from "../../../FetchMethod";
import SearchIcon from "../../assets/search.png";
import { TextField, Button, Drawer, IconButton } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import "../CampaignTables.css";
import "../CampaignTabs.css";
import "./CampaignNoOpTab.css";
import "./CampaignLeadsTab.css";
//import Photo from "../../assets/photo.png";
import ExportTo from "./LeadToExcel";
import { Checkbox } from "pretty-checkbox-react";
import LeadsDetails from "./LeadsDetails";
import swal from "sweetalert";
import LeadTo from "./LeadTo";
const moment = require("moment");

class CampaignLeadsTab extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      loading: false,
      limit: 0,
      offset: 0,
      searchFlag: false,
      coulmnFilter: "",
      shortfilter: false,
      clickToSearch: false,
      campaignLeadsTableList: [],
      campaignLeadsList: [],
      totalCount: 0,
      show: "",
      Currentstage: [],
      invitationSent: [],
      selected: {},
      selectAll: 0,
      selectedArray: [],
      campaignLeadsAllSelectedList: [],
      profileid: undefined,
      salesforcetoken: null,
      hubspottoken: null,
      isSearching: false,
      campaignLeadsExportData: [],
      Row: ""
    };
  }

  componentDidMount() {
    this.ExportData();
    this.setState({ show: false }, () =>
      this.props.detailEdit(this.state.show)
    );
    this.Profile();
  }

  ExportData = () => {
    const filter = this.filter();
    fetchMethod(campaignLeadsExport, filter)
      .then(res => res.json())
      .then(res => {
        this.setState({
          campaignLeadsExportData: res.data.allContacts.Contacts
        });
      });
  };

  Profile = () => {
    fetchMethod(Profileid(this.props.campaignId))
      .then(res => res.json())
      .then(res => {
        this.setState({
          profileid:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].id,
          hubspottoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].hubspottoken,
          salesforcetoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].salesforcetoken
        });
      })
      .catch(e => console.log(e));
  };
  emptySelectedArray = () => {
    this.setState({ selectedArray: [], selectAll: false, selected: {} });
  };
  handleDateChange = date => {
    this.setState({
      selectedDate: date
    });
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };
  fetchContactDrawerDetails = (side, open, row) => event => {
    fetchMethod(Engaged(row.id))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            ContactDetailsWorkflow:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactworkflowhistoryfk
                  .Contactworkflowhistories
                : "",

            ContactDetailsMessages:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactmessagesfk
                  .Contactmessages
                : "",
            getData:
              res.data.allContacts !== undefined &&
                res.data.allContacts !== null
                ? res.data.allContacts.Contacts[0]
                : "",
            getCampaignId:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignid
                : "",
            getCustomer:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null &&
                res.data.allContacts.Contacts[0].Campaigns.Campaigns.length > 0
                ? res.data.allContacts.Contacts[0].Campaigns.Campaigns[0]
                  .Customers.Customers[0]
                : "",
            contactStatus:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].contactstatus
                : "",
            campaignStatus:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignstatus
                : "",
            contactId:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].id
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => swal({ title: e, icon: "warning" }));
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ ...this.state, [side]: open });
  };
  closeDetails = () => {
    this.setState({ openDetails: false });
  };
  setLeadsListData = response => {
    this.setState({
      campaignLeadsList: response.data.allContacts.Contacts,
      totalCount: response.data.allContacts.totalCount
    });
  };

  onSearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      });
    }
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  debounceTimer = null;
  handleChange = event => {
    this.setState({
      search: event.target.value,
      searchFlag: true,
      isSearching: true
    });
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.onSearchClick();
        this.setState({ isSearching: false });
      },
      200
    );
  };

  fetchRefresh = response => {
    this.fetchMessage(response);
  };
  fetchMessage = response => {
    fetchMethod(Engaged(response))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            ContactDetailsMessages:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactmessagesfk
                  .Contactmessages
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => swal({ title: e, icon: "warning" }));
  };

  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };
  gettingAllDataFromQuery = () => {
    const filter = this.filter();
    fetchMethod(campaignLeadsTabSelectList, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        let allselectedIds = [];
        responseAsJson.data.allContacts.Contacts.map(i => {
          allselectedIds.push({ id: i.id });
        });
        this.setState(
          {
            campaignLeadsTabSelectList: allselectedIds
          },
          () => {
            let selectedArr = [];
            let consolidateArray = [];
            this.state.campaignLeadsTabSelectList.map(item => {
              consolidateArray[item.id] = true;
              selectedArr.push({ id: item.id });
            });
            this.setState({
              selectAll: true,
              selected: consolidateArray,
              selectedArray: selectedArr
            });
          }
        );
      })
      .catch(e => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  onRowSelected = sarray => {
    if (sarray.length === this.state.totalCount) {
      this.setState({ selectAll: true });
    } else {
      this.setState({ selectAll: false });
    }
  };

  toggleRowNew = (id, rowInfo) => {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected
    });
    const { selectedArray } = this.state;
    let arr = selectedArray.filter(val => val.id !== id);
    if (!arr.length) {
      this.setState(
        {
          selectedArray: []
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
    if (arr.length === selectedArray.length) {
      this.setState(
        {
          selectedArray: [...selectedArray, rowInfo]
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    } else {
      this.setState(
        {
          selectedArray: arr
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
  };

  toggleSelectAllRow = isChecked => {
    if (isChecked) {
      this.gettingAllDataFromQuery();
    } else {
      this.setState({
        selectAll: false,
        selectedArray: [],
        selected: {}
      });
    }
  };

  clearFilters = () => {
    this.setState(
      {
        search: "",
        searchFlag: false,
        clickToSearch: false,
        limit: 50,
        offset: 50
      },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      }
    );
  };

  formatDate = date => {
    if (date !== null && date !== undefined && date && date !== "Yes") {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }
    return;
  };
  formatDate2 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${mm}/${dd}/${yyyy}`;
      return date;
    }
    return;
  };

  NameFilter = () => {
    this.setState({ columnFilter: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ columnFilter: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  CompanyFilter = () => {
    this.setState(
      { columnFilter: "organization asc", shortfilter: true },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
      }
    );
  };
  CompanyFilter1 = () => {
    this.setState(
      { columnFilter: "organization desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  PositionFilter = () => {
    this.setState({ columnFilter: "designation asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  PositionFilter1 = () => {
    this.setState(
      { columnFilter: "designation desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LocationFilter = () => {
    this.setState({ columnFilter: "location asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  LocationFilter1 = () => {
    this.setState({ columnFilter: "location desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  connectedonFilter = () => {
    this.setState({ columnFilter: "connectedon asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  connectedonFilter1 = () => {
    this.setState(
      { columnFilter: "connectedon desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  InvitationsentFilter = () => {
    this.setState(
      { columnFilter: "invitationsent asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  InvitationsentFilter1 = () => {
    this.setState(
      { columnFilter: "invitationsent desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  currentstatusFilter = () => {
    this.setState(
      { columnFilter: "currentstatus asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  currentstatusFilter1 = () => {
    this.setState(
      { columnFilter: "currentstatus desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  LeadsTypeFilter = () => {
    this.setState(
      { columnFilter: "ContactStatus asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LeadsTypeFilter1 = () => {
    this.setState(
      { columnFilter: "ContactStatus desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  filter = () => {
    const search = this.state.clickToSearch ? this.state.search : "";
    const like = "%" + `${search}` + "%";

    const filter = {
      where: {
        active: "1",
        leads: "1",
        campaignid: this.props.campaignId,
        contactstatus: {
          nlike: "%noop%",
          options: "i"
        },

        order: this.state.columnFilter,

        and: [
          {
            or: [
              { name: { like: like, options: "i" } },
              { location: { like: like, options: "i" } },
              { designation: { like: like, options: "i" } },
              { organization: { like: like, options: "i" } }
            ]
          }
        ]
      }
    };
    return filter;
  };

  formatDate3 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(date);
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };
  handleStatusChange2 = (row, updateStatus, date) => event => {
    updateStatus = {
      where: { id: row.original.id },
      data: {
        followup: this.formatDate3(event)
      }
    };

    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(UpdatefollowUp, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            if (res.data.ContactsUpsertWithWhere) {
              swal("Successfully updated", { icon: "success" }).then(() => {
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
              });
            } else swal("Error", { icon: "error" });
          })

          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };

  showEngagedToPopup = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },
      clientY: e.clientY,
      clientX: e.clientX
    });
  };
  onCloseEngagedPopup = () => {
    this.setState({ selectedEngagedRow: null });
  };

  showEngagedToPopup = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },
      clientY: e.clientY,
      clientX: e.clientX
    });
  };
  onCloseEngagedPopup = () => {
    this.setState({ selectedEngagedRow: null });
  };

  onTableRowClick = rowInfo => {
    this.setState({ Row: rowInfo.original.id });
  };
  render() {
    const { selectedEngagedRow } = this.state;
    const campaignLeadsList = [...this.state.campaignLeadsList];
    const campaignLeadsExportData = [...this.state.campaignLeadsExportData];
    const CampaignLeadsListHeaders = [
      {
        Header: obj => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style="thick"
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selectAll}
              onChange={e => {
                this.toggleSelectAllRow(e.target.checked);
              }}
            />
          );
        },
        width: 38,
        Cell: rowInfo => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style="thick"
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selected[rowInfo.original.id] === true}
              onChange={() =>
                this.toggleRowNew(rowInfo.original.id, rowInfo.original)
              }
            />
          );
        }
      },
      {
        Header: "Image",
        accessor: "Image",

      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Name
            </div>
          );
        },
        accessor: "name",
        width: 150,
        Cell: row => (
          <div
            style={{ cursor: "pointer", color: "#2BADDD" }}
            onClick={this.fetchContactDrawerDetails(
              "openDetails",
              true,
              row.original
            )}
          >
            {row.original.name}
          </div>
        )
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.CompanyFilter
                  : this.CompanyFilter1
              }
            >
              Current Company
            </div>
          );
        },
        accessor: "organization",
        width: 150,
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.PositionFilter
                  : this.PositionFilter1
              }
            >
              Current Position
            </div>
          );
        },
        accessor: "designation",
        width: 150,
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LocationFilter
                  : this.LocationFilter1
              }
            >
              Location
            </div>
          );
        },
        accessor: "location",
        width: 150,
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.connectedonFilter
                  : this.connectedonFilter1
              }
            >
              Connected On
            </div>
          );
        },
        accessor: "Connectedon",
        width: 110,
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LeadsTypeFilter
                  : this.LeadsTypeFilter1
              }
            >
              Lead Type
            </div>
          );
        },
        accessor: "ContactStatus"
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.InvitationsentFilter
                  : this.InvitationsentFilter1
              }
            >
              Invitation Sent
            </div>
          );
        },
        accessor: "InvitationSent",
        width: 110,
      },

      {
        Header: "Last Response",
        accessor: "LR",
        width: 110,
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
            >
              Follow Up
            </div>
          );
        },


        Cell: row => {
          return (
            <div
              className="iconButton"
              style={{
                color: row.original.followup2 == 1 ? "#FFBF00" : "red"
              }}
            >
              {row.original.followup}

              <span className="EditIcon">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    format="dd/MM/yyyy"
                    value=""

                    onChange={this.handleStatusChange2(row)}
                    keyboardIcon={
                      <img src={editicon} alt="" style={{ width: "17px" }} />
                    }
                    InputProps={{
                      disableUnderline: true
                    }}
                    helperText={""}
                  />
                </MuiPickersUtilsProvider>
              </span>
            </div>
          );
        }
      },
      {
        Header: " Status",
        accessor: "CampaignStatus"
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.currentstatusFilter
                  : this.currentstatusFilter1
              }
            >
              Current Stage
            </div>
          );
        },
        accessor: "CurrentStage"
      },
      {
        Header: "",
        accessor: "Kebab_Menu",
        Cell: rowInfo => (
          <div className="iconButton">
            {localStorage.getItem("role") !== "CUSTOMER" ? (
              <IconButton
                aria-haspopup="true"
                onClick={this.showEngagedToPopup(rowInfo)}
              >
                <MoreVertIcon />
              </IconButton>
            ) : (
              ""
            )}
          </div>
        )
      }
    ];

    campaignLeadsList.map(list => {

      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = this.formatDate(list.lastresponse.split("T")[0]);
      }
      if (
        list.followup !== undefined &&
        list.followup !== null &&
        list.followup !== "" &&
        list.followup
      ) {
        var date = this.formatDate2(list.followup.split("T")[0]);
        var cmTime = new Date(date);
        var dateday = cmTime.getDay();
        if (dateday >= 3) {

          var lastDay = cmTime;
          lastDay.setDate(cmTime.getDate() + 5);
          var today = new Date();
          if (lastDay > today) {
            list.followup2 = 1;
          } else {
            list.followup2 = 0;
          }
        } else {

          var lastDay = cmTime;
          lastDay.setDate(cmTime.getDate() + 3);
          var today = new Date();
          if (lastDay > today) {
            list.followup2 = 1;
          } else {
            list.followup2 = 0;
          }
        }
      }
      if (
        list.followup !== undefined &&
        list.followup !== null &&
        list.followup
      ) {
        list.followup = this.formatDate(list.followup.split("T")[0]);
      }

      let image =
        list.profileimage !== undefined && list.profileimage !== null
          ? list.profileimage.substr(0, 5)
          : "";
      let imageSourceUrl = getContactImageUrl;
      if (image === "https") {
        if (list.id > 917500) {
          imageSourceUrl = getContactImageUrl2;
        }
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={list.profileimage}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = imageSourceUrl.url + list.image;
              }}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      } else {
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={imageSourceUrl.url + list.image}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      }


      list.ContactStatus =
        list.contactstatus === "SUSPECT"
          ? "Suspect"
          : list.contactstatus === "PROSPECT"
            ? "Prospect"
            : list.contactstatus === "OPPORTUNITY"
              ? "Opportunity"
              : list.contactstatus;

      list.organization =
        list.organization !== undefined && list.organization !== null
          ? list.organization
          : "";
      list.CampaignStatus =
        list.campaignstatus !== null && list.campaignstatus !== undefined
          ? list.campaignstatus === "COMPLETED"
            ? "Completed"
            : list.campaignstatus === "PAUSE"
              ? "Pause"
              : "Live"
          : "";


      if (
        list.connectedon !== undefined &&
        list.connectedon !== null &&
        list.connectedon
      ) {
        list.Connectedon = this.formatDate(list.connectedon);
      }

      if (
        list.invitationsent !== undefined &&
        list.invitationsent !== null &&
        list.invitationsent
      ) {
        list.InvitationSent = this.formatDate(
          list.invitationsent.split("T")[0]
        );
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        if (
          list.invitesent == 0 &&
          (list.currentstatus == "Invite Sent" ||
            list.currentstatus == "Invite Not Sent")
        ) {
          list.CurrentStage = "Invite not Sent";
        } else {
          list.CurrentStage = list.currentstatus;
        }
      }

      return null;
    });

    campaignLeadsExportData.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = list.lastresponse;
      }
      if (
        list.invitationsent !== undefined &&
        list.invitationsent !== null &&
        list.invitationsent
      ) {
        list.InvitationSent = list.invitationsent.split("T")[0];
      }
      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }
    });

    const filterr = this.filter();
    return (
      <div className="CampaignLeadsTab">
        <div className="CampaignLeadsHeader">
          <div className="CampaignLeadsLeftFilters">
            <div className="searchContact">
              <Drawer
                anchor="right"
                open={this.state.openDetails}
                onClose={() => this.closeDetails()}
              >
                <LeadsDetails
                  onSearchClick={this.onSearchClick}
                  refreshMessage={this.fetchRefresh}
                  Close={() => this.closeDetails()}
                  details={this.state.getData}
                  Campaignid={this.state.getCampaignId}
                  Customer={this.state.getCustomer}
                  contactStatus={this.state.contactStatus}
                  campaignStatus={this.state.campaignStatus}
                  id={this.state.contactId}
                  // id={row.id}
                  tableRerender={this.child.current}
                  limit={this.state.limit}
                  offset={this.state.offset}
                  ContactDetailsWorkflow={this.state.ContactDetailsWorkflow}
                  ContactDetailsMessages={this.state.ContactDetailsMessages}
                  heading={"Leads Details"}
                />
              </Drawer>
              <TextField
                id="outlined-search"
                label="Search"
                placeholder="Company/name/position/location"
                type="text"
                margin="normal"
                variant="outlined"
                value={this.state.search}
                onChange={this.handleChange}
                onKeyDown={this.onSearchKeyDown}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <img
                      src={SearchIcon}
                      style={{ width: "15px", cursor: "pointer" }}
                      onClick={() => this.onSearchClick()}
                    />
                  )
                }}
              />
            </div>
          </div>
          {selectedEngagedRow && (
            <LeadTo
              target={selectedEngagedRow && selectedEngagedRow.anchorEl}
              contactStatus={selectedEngagedRow.original.contactstatus}
              campaignStatus={selectedEngagedRow.original.campaignstatus}
              id={selectedEngagedRow.original.id}
              clientY={this.state.clientY}
              clientX={this.state.clientX}
              tableRerender={this.child.current}
              limit={this.state.limit}
              offset={this.state.offset}
              onClose={this.onCloseEngagedPopup}
            />
          )}

          <div style={{ minWidth: "130px" }}>
            <p style={{ color: "#36454d", fontSize: "15px" }}>
              Total Records: <span>{this.state.totalCount}</span>
            </p>
          </div>
          <div className="CampaignLeadsButton">
            <Button className="button" onClick={this.clearFilters}>
              <span style={{ textTransform: "capitalize" }}> Reset All</span>
            </Button>
          </div>
          <div className="RightContext">
            <ExportTo
              fileData={campaignLeadsExportData}
              SalesHubdata={this.state.selectedArray}
              Profile={this.state.profileid}
              selectedArray={this.emptySelectedArray}
              SalesforceToken={this.state.salesforcetoken}
              HubspotToken={this.state.hubspottoken}
            />
          </div>
        </div>
        <ReactTableComponent
          ref={this.child}
          listData={this.state.campaignLeadsList}
          listConfig={CampaignLeadsListHeaders}
          setData={this.setLeadsListData}
          query={campaignLeadsTabList}
          totalCount={this.state.totalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filterr}
          clickToSearch={this.state.clickToSearch}
          onRowClick={this.onTableRowClick}
        />
      </div>
    );
  }
}
export default CampaignLeadsTab;
